import React from "react";
import { Save } from "lucide-react";
import "../../styles/FormCard.css";

const SaveButton = ({ onClick, text = "Enregistrer", isLoading = false, disabled = false }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled || isLoading}
      className="save-button"
    >
      {isLoading ? (
        <>
          <span className="spinner"></span>
          Enregistrement...
        </>
      ) : (
        <>
          <Save size={18} />
          {text}
        </>
      )}
    </button>
  );
};

export default SaveButton;
